'use client';

export const PdpDisableHeader = () => (
  <style>
    {`
      @media (max-width: 767px) {
        div#header-mobile-tablet-search {
          display: none !important;
        }
        div#header-navigation {
          padding-bottom: 0.5rem !important;
        }
      }
    `}
  </style>
);
